import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appSubstring'
})
export class SubstringPipe implements PipeTransform {
  transform(value: string, start: number, end?: number): string {
    return value == null ? null : value.slice(start, end);
  }
}
